import React, { Fragment } from 'react'
import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'
import Container from '@material-ui/core/Container'
import * as firebase from 'firebase/app'
import 'firebase/firestore'
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  paper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}))

export default function LoginForm(props) {
  const classes = useStyles()
  const [email, setUsername] = React.useState('')
  const [password, setPassword] = React.useState('')
  const [open, setOpen] = React.useState(false)

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }
  return (
    <Fragment>
      <Container component='main' maxWidth='md'>
        <div className={classes.paper}>
          <Typography component='h1' variant='h4'>
            Giriş Yapın
          </Typography>
          <form className={classes.form}>
            <TextField
              variant='outlined'
              margin='normal'
              required
              fullWidth
              id='email'
              label='Email'
              name='email'
              autoFocus
              onInput={(e) => setUsername(e.target.value)}
            />

            <TextField
              variant='outlined'
              margin='normal'
              required
              fullWidth
              type='password'
              id='password'
              label='Şifre'
              name='password'
              autoFocus
              onInput={(e) => setPassword(e.target.value)}
            />

            <Button
              type='submit'
              fullWidth
              variant='contained'
              color='primary'
              className={classes.submit}
              onClick={async (e) => {
                firebase
                  .auth()
                  .signInWithEmailAndPassword(email, password)
                  .catch(function (error) {
                    var errorCode = error.code
                    var errorMessage = error.message
                    console.log(errorCode, errorMessage)
                    handleClickOpen()
                  })
                firebase.auth().onAuthStateChanged(function (user) {
                  if (user) {
                    localStorage.setItem('user', user)
                    props.setUser(user)
                  } else {
                  }
                })
                e.preventDefault()
              }}
            >
              Gönder
            </Button>
          </form>
        </div>
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby='alert-dialog-title'
          aria-describedby='alert-dialog-description'
        >
          <DialogTitle id='alert-dialog-title'>
            {'Yanlış Email veya Şifre girdiniz.'}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id='alert-dialog-description'>
              Lütfen giriş bilgilerinizi düzelttikten sonra tekrar deneyiniz.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color='primary' autoFocus>
              Tamam
            </Button>
          </DialogActions>
        </Dialog>
      </Container>
    </Fragment>
  )
}
